import { render, staticRenderFns } from "./SwitchAccessableCompany.vue?vue&type=template&id=e2ba8482&scoped=true"
import script from "./SwitchAccessableCompany.vue?vue&type=script&lang=js"
export * from "./SwitchAccessableCompany.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccessableCompany.vue?vue&type=style&index=0&id=e2ba8482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ba8482",
  null
  
)

export default component.exports